var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-backToTop mb"},[_c('button',{attrs:{"aria-label":"back to top"},on:{"click":_vm.smoothScroll}},[_c('img',{staticClass:"icon",attrs:{"src":require("../assets/large_arrow.svg"),"alt":"Right Arrow"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2373383a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackToTop.vue
// module id = null
// module chunks = 